import {
  APIHomePageResponse,
  APIHomePageSavePayload,
  ArdoqId,
} from '@ardoq/api-types';
import {
  fetchEntities,
  fetchJson,
  headers,
  Method,
  toRequestOptions,
} from './api';
import { ApiResponse } from './types';

const fetchHomePage = (): ApiResponse<APIHomePageResponse> => {
  const request = new Request('/api/page/home/content', { headers });
  return fetchJson<APIHomePageResponse>(request);
};

const updateHomePage = (
  id: ArdoqId,
  homePageConfig: APIHomePageSavePayload
): ApiResponse<APIHomePageResponse> => {
  const request = new Request(
    `/api/page/${id}`,
    toRequestOptions(Method.PUT, homePageConfig)
  );
  return fetchJson<APIHomePageResponse>(request);
};

const createHomePage = (
  homePageConfig: Omit<APIHomePageSavePayload, '_id' | '_version'>
) => {
  const request = new Request(
    `/api/page`,
    toRequestOptions(Method.POST, homePageConfig)
  );
  return fetchJson<APIHomePageResponse>(request);
};

export const pageApi = {
  fetchAll: fetchEntities<APIHomePageResponse>('page'),
  fetchHomePage,
  updateHomePage,
  createHomePage,
};
